/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Backward1': {
    width: 24,
    height: 25,
    viewBox: '0 0 24 25',
    data: '<path pid="0" d="M12 24.653c5.908 0 10.8-4.892 10.8-10.8 0-5.21-3.801-9.625-8.757-10.599V1.751c0-.752-.518-.953-1.09-.54L9.575 3.57c-.487.34-.497.848 0 1.197l3.367 2.372c.583.424 1.101.222 1.101-.54V5.086c4.003.91 6.946 4.479 6.946 8.767 0 4.998-3.991 9-8.989 9a8.959 8.959 0 01-9-9c.01-3.007 1.472-5.665 3.727-7.274.434-.328.572-.826.307-1.27-.265-.435-.847-.551-1.313-.191C3 7.098 1.2 10.295 1.2 13.853c0 5.908 4.902 10.8 10.8 10.8z" _fill="#00204D" _stroke="#00204D" stroke-width=".6"/>'
  }
})
